import { render, staticRenderFns } from "./trash-papers-list.html?vue&type=template&id=d55a023c&scoped=true&"
import script from "./trash-papers-list.js?vue&type=script&lang=js&"
export * from "./trash-papers-list.js?vue&type=script&lang=js&"
import style0 from "./trash-papers-list.scss?vue&type=style&index=0&id=d55a023c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55a023c",
  null
  
)

export default component.exports